export default __webpack_public_path__ + "static/1628-803720c5300b5e9c66e0d81ebceb24a3.jpg";